import { useCallback, useEffect, useState } from 'react'
import { Alert, Col, message, Row, Space } from 'antd'
import _, { omitBy } from 'lodash'
import {
  ButtonActionBar,
  Comments,
  PercentageTable,
  ProgressBar,
  Typography,
} from 'modules/core/components'
import { connect } from 'react-redux'
import { Prompt, useParams } from 'react-router-dom'
import { CommentOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { handleApply, handleCellEdit, handleUnApply } from './utils'
import planning from '../../../../../../index'
import ActionBar from './components/ActionBar'
import configuration from 'modules/configuration'
import login from 'modules/login'
import { generateMessageError, sendUserDataToGTM } from 'modules/core/utils'
import control from 'modules/control'

const Percentage = (props) => {
  const {
    loading,
    dataPhase,
    budgetInstance,
    dataRdnPercentagePlanning,
    currentRdnSelect,
    businessRulesOption,
    handleRdnChange,
    ruleTypeValue,
    updateTransactionPercentage,
    reloadTablePercentage,
    applyRdnTransactionPercentage,
    unApplyRdnTransactionPercentage,
    setData,
    comments,
    onRefetchComments,
    loadingComments,
    loggedUser,
    setHasComment,
    hasComment,
    createComment,
    removeNewComment,
    showProgressBar,
    canUserABM,
    tabKey,
    budgetInstanceDetail,
    showTableqp,
    setShowTableqp,
    setShowAlert,
    settings,
    setSettings,
    layoutList,
    fetchLayoutList,
  } = props
  // Hooks
  const { budgetId, periodId } = useParams()
  // State
  const [viewComment, setViewComment] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [dataLocalStorage, setDataLocalStorage] = useState(localStorage.getItem('dataTable'))
  const { t } = useTranslation()
  // Values
  const baseDataSend = {
    concept_id: budgetInstance?.concept_id,
    period_id: periodId,
    step: dataPhase.key,
  }
  const key = window.location.pathname.replaceAll('/', '-')

  var queryString = window.location.search
  var urlParams = new URLSearchParams(queryString)
  var table = urlParams.get('table')
  var url_hash = urlParams.get('hash_url')

  useEffect(() => {
    const onCustom = (e) => {
      if (e?.detail?.key === 'dataTable') setDataLocalStorage(e.detail.value)
    }

    window.addEventListener('local-storage', onCustom)
    return () => {
      window.removeEventListener('local-storage', onCustom)
    }
  }, [])

  useEffect(() => {
    if (!dataLocalStorage && !url_hash && layoutList.values.length === 0) {
      setSettings({})
    }

    const dataTable = JSON.parse(dataLocalStorage)

    if (dataLocalStorage) {
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable[tabKey],
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })
    }

    const layoutsUrlHash = layoutList.values.filter((el) => el.url_hash && url_hash === el.url_hash)

    if (url_hash && !dataTable[tabKey] && layoutsUrlHash.length > 0) {
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...layoutsUrlHash[0].config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })
    }
  }, [dataLocalStorage, url_hash, tabKey, layoutList.values])

  useEffect(() => {
    if (currentRdnSelect) {
      window.history.replaceState(
        null,
        '',
        `/planificacion/${periodId}/${budgetInstanceDetail?.concept_name}/${budgetId}/${
          dataPhase.key
        }/${tabKey}?rule=${currentRdnSelect}${url_hash ? `&hash_url=${url_hash}` : ''}`, //${table ? `&table=${table}` : ''}`,
      )
    }
  }, [
    periodId,
    budgetId,
    budgetInstanceDetail,
    tabKey,
    dataPhase,
    currentRdnSelect,
    table,
    url_hash,
  ])

  useEffect(() => {
    const endpointParam = { ...(url_hash && { url_hash }) }
    fetchLayoutList('planning', `${budgetId}-${dataPhase.key}`, endpointParam)
  }, [fetchLayoutList, budgetId, dataPhase.key, url_hash])

  const normalizedData = (rows) => {
    const filters = {
      ...rows,
      date: rows.Fecha,
      Fecha: undefined,
    }
    return omitBy(filters, (prop) => prop == null)
  }

  const handleCreate = ({ text, usersIds, idComment = null, setIsNewThread }) => {
    const dataa = {
      text,
      key: `${key}-${dataPhase.key}-table-percentage`,
      module: `${key}-${dataPhase.key}`,
      mentions: usersIds,
      ...(idComment && {
        parent: idComment,
      }),
    }
    setIsSaving(true)
    createComment(dataa)
      .then(() =>
        onRefetchComments().then(() => {
          message.success(t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
          setIsSaving(false)
          setIsNewThread(false)
        }),
      )
      .catch((error) => {
        message.error(generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL_MESSAGE'), 8)
        setIsSaving(false)
        setIsNewThread(false)
      })
  }

  const renderTableActions = () => (
    <ButtonActionBar position="space-between">
      <div />
      <Space>
        {(viewComment ||
          comments.filter(
            (el) => el.key === `${key}-${dataPhase.key}-table-percentage` && !el.resolved,
          ).length > 0) && (
          <Comments
            hasComment={hasComment.table}
            onClick={(visible) => {
              setHasComment({ type: 'table', data: visible })
              !visible && removeNewComment()
              !visible && setViewComment(visible)
            }}
            comments={comments.filter(
              (el) =>
                (el.key === `${key}-${dataPhase.key}-table-percentage` && !el.resolved) || !el.text,
            )}
            setData={setData}
            loading={loadingComments || isSaving}
            onRefetchComments={onRefetchComments}
            onCommentCreate={(text, usersIds, idComment, setIsNewThread) =>
              handleCreate({ text, usersIds, idComment, setIsNewThread })
            }
            onCleanHasComment={() => {
              setHasComment({ type: 'table', data: false })
              setViewComment(false)
            }}
          >
            <Typography.Icon
              style={{ cursor: 'pointer' }}
              title={t('LABEL_COMMENTS')}
              icon={CommentOutlined}
            />
          </Comments>
        )}
      </Space>
    </ButtonActionBar>
  )

  const handleClick = (key) => {
    handleRdnChange(key)
    window.history.replaceState(
      null,
      '',
      `/planificacion/${periodId}/${budgetInstanceDetail?.concept_name}/${budgetId}/${dataPhase.key}/${tabKey}?rule=${key}`,
    )
  }

  const handleBeforeUnload = useCallback(() => {
    localStorage.removeItem('dataTable')
  }, [])

  return (
    <>
      <Prompt
        when={localStorage.getItem('dataTable')}
        message={(nextLocation) => {
          handleBeforeUnload()
          return true
        }}
      />
      <Row gutter={[6, 6]}>
        <Col span={24}>
          <Alert
            message={t(
              'PLANNING_PORCENTUAL_TABLE_ONLY_INDIVIDUAL_RULES_INFORMATIVE_ALERT_DESCRIPTION',
            )}
            type="warning"
            showIcon
          />
        </Col>
        <Col span={24}>
          <ActionBar
            rdnDefault={currentRdnSelect}
            rdnOptions={businessRulesOption}
            handleRdnChange={(value) => handleClick(value)}
            onApplyConfirmPopConfirm={() =>
              handleApply({
                applyRdnPercentage: () =>
                  applyRdnTransactionPercentage(currentRdnSelect, budgetId, baseDataSend),
                onRefetch: reloadTablePercentage,
                setShowAlert,
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(
                    loggedUser,
                    'Planificación',
                    'Aplicar regla porcentual presupuesto',
                    'Aplicación',
                  ),
              })
            }
            onUnApplyConfirmPopConfirm={() =>
              handleUnApply({
                unApplyRdnPercentage: () =>
                  unApplyRdnTransactionPercentage(currentRdnSelect, budgetId, baseDataSend),
                onRefetch: reloadTablePercentage,
                setShowAlert,
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(
                    loggedUser,
                    'Planificación',
                    'Desaplicar regla porcentual presupuesto',
                    'Desaplicación',
                  ),
              })
            }
            hasApplyOrUnApply={!canUserABM}
          />
          <br />
        </Col>
        <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
          {showProgressBar && <ProgressBar isLoading={loading} />}
        </Col>
        <Col span={24}>{renderTableActions()}</Col>
        <Col span={24}>
          <PercentageTable
            loading={loading}
            settings={settings}
            setSettings={setSettings}
            dataPercentageTable={dataRdnPercentagePlanning}
            onCellEdit={(amount, row, type_change) => {
              const dataSend = {
                ...baseDataSend,
                amount,
                row: normalizedData(row),
                type_change,
                planning_id: budgetId,
                business_rule_id: currentRdnSelect,
              }
              handleCellEdit({
                updateTransactionPercentage: () => updateTransactionPercentage(dataSend),
                onRefetch: reloadTablePercentage,
                setShowAlert,
                sendUserDataToGTM: () =>
                  sendUserDataToGTM(
                    loggedUser,
                    'Planificación',
                    'Editar celda regla porcentual presupuesto',
                    'Edición',
                  ),
              })
            }}
            hasComment={hasComment}
            setHasComment={setHasComment}
            setViewComment={setViewComment}
            hasCellEdit={canUserABM}
            ruleTypeValue={ruleTypeValue}
            url={`/planificacion/${periodId}/${budgetInstanceDetail?.concept_name}/${budgetInstanceDetail?.id}/${dataPhase.key}/${tabKey}`}
            showTableqp={showTableqp}
            setShowTableqp={setShowTableqp}
            ruleId={currentRdnSelect}
            tabKey={tabKey}
          />
        </Col>
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  dataRdnPercentagePlanning: planning.selectors.getDataRdnPercentagePlanning(state),
  hasComment: configuration.selectors.getHasComment(state),
  loggedUser: login.selectors.getWhoAmI(state),
  layoutList: control.selectors.getLayoutList(state),
})

const mapDispatchToProps = {
  updateTransactionPercentage: planning.actions.updateTransactionPercentageByPlanning,
  applyRdnTransactionPercentage: planning.actions.applyRdnPercentageByPlanning,
  unApplyRdnTransactionPercentage: planning.actions.unApplyRdnPercentageByPlanning,
  setHasComment: configuration.actions.setHasComment,
  createComment: configuration.actions.createComment,
  removeNewComment: configuration.actions.removeNewComment,
  fetchLayoutList: control.actions.fetchLayoutList,
}

export default connect(mapStateToProps, mapDispatchToProps)(Percentage)
